import styled from "styled-components";

export const Trigger = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  width: 100%;
  min-height: 36px;
  padding: 4px 32px 4px 8px;
  position: relative;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid ${({ $open }) => ($open ? "#11a7d9" : "#e4e4e7")};
  background: ${({ $disabled }) => ($disabled ? "#f5f5f5" : "#fff")};
  cursor: ${({ $disabled }) => ($disabled ? "not-allowed" : "pointer")};

  &:hover {
    border-color: ${({ $disabled }) => ($disabled ? "#e4e4e7" : "#11a7d9")};
  }
`;

export const Placeholder = styled.span`
  color: rgba(0, 0, 0, 0.45);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  padding: 2px 4px;
`;

export const Chip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 1px 6px 1px 8px;
  background: #f4f4f5;
  border: 1px solid #e4e4e7;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.88);
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
`;

export const ChipRemove = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.45);

  &:hover {
    color: #f5222d;
  }
`;

export const Chevron = styled.span`
  position: absolute;
  right: 8px;
  top: 50%;
  display: inline-flex;
  color: rgba(0, 0, 0, 0.45);
  transform: translateY(-50%) rotate(${({ $open }) => ($open ? "180deg" : "0deg")});
  transition: transform 0.15s ease;
  pointer-events: none;
`;

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 260px;
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 3px 6px -4px rgba(0, 0, 0, 0.12),
    0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
`;

export const MenuItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  background: ${({ $selected }) => ($selected ? "#e6f4ff" : "transparent")};
  cursor: pointer;
  color: ${({ $selected }) => ($selected ? "#11a7d9" : "rgba(0, 0, 0, 0.88)")};
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: ${({ $selected }) => ($selected ? 600 : 400)};
  text-align: left;
  white-space: nowrap;

  &:hover {
    background: ${({ $selected }) => ($selected ? "#e6f4ff" : "#f5f5f5")};
  }
`;

export const EmptyMenu = styled.div`
  padding: 12px;
  color: rgba(0, 0, 0, 0.45);
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  text-align: center;
`;
